import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2InformationOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32"><path d="M2 16.05c0-7.72 6.28-14 14-14s14 6.28 14 14c0 7.383-5.747 13.434-13 13.95v-2c6.15-.511 11-5.67 11-11.95 0-6.616-5.383-12-12-12s-12 5.384-12 12c0 6.234 4.779 11.37 10.865 11.943l-1.284 1.834C7.012 28.676 2 22.944 2 16.05m15-1.37h-2v8.03h2zm0-4.297h-2v2h2z" /></svg>
);
